import styled from "styled-components";

export const getNodePath = (node: any, treeDataState: any): any => {
    let f: any = {
        key: node.key
    };
    let str = "";
    while (f != undefined) {
        let tempKey = f.key;
        f = (getParentNode(tempKey, treeDataState));
        str = f ? f.title + "/" + str : str
    }
    str = str + node.title;
    return str;
}

export const getParentNode = (key: any, tree: any): any => {
    let parentTitle: any;
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
            if (node.children.some((item: any) => {
                return item.key === key
            })) {
                parentTitle = node;
            } else if (getParentNode(key, node.children)) {
                parentTitle = getParentNode(key, node.children);
            }
        }
    }
    return parentTitle;
}

export const ButtonWrapper = styled.div`
padding:1px
`